module.exports = __webpack_public_path__ + "static/media/image4.e1077bfb.png";